<template lang="pug">
    .page
        .content-container
            .news-item(v-for="(item, index) in list" :key="index")
                img(:src="item.thumbnail")
                .content
                    .title {{item.title}}
                    .dec {{item.introduction}}
                    .more(@click="handleGoDetail(item)") 了解更多
        .more-btn(v-if="more", @click="onGetDataListMore") 更多新闻
</template>

<script>
import axios from 'axios'

export default {
    name: 'News',
    data() {
        return {
            list: [],
            page: 1,
            limit: 15,
            more: false
        }
    },
    methods: {
        onGetDataList() {
            axios.get(`/api/article/?page=${this.page}&limit=${this.limit}`).then(res => {
                this.list = res.data.items
                this.more = res.data.num_items_per_page < this.limit
            })
        },
        onGetDataListMore() {
            if (this.more) {
                this.page++
                axios.get(`/api/article?page=${this.page}&limit=${this.limit}`).then(res => {
                    this.list = this.list.concat(res.data.items)
                    this.more = res.data.num_items_per_page < this.limit
                })
            }
        },
        handleGoDetail(_item) {
            this.$router.push({ path: '/news/' + _item.id})
        }
    },
    created() {
        this.onGetDataList()
    }
}
</script>

<style lang="sass" scoped>
.page
    width: 100%
    background: #f9f9f9
    padding-top: 20px
    .banner
        width: 100%
    .content-container
        max-width: 1000px
        margin: 0 auto
        min-height: 1030px
        padding-top: 60px
        .news-item
            cursor: pointer
            background: #fff
            margin-bottom: 30px
            transition: all 1s
            padding: 20px
            &:hover
                box-shadow: 0 5px 5px 0px #eee
            img
                background: #eee
                display: block
                width: 100%
            .content
                padding: 30px
                .title
                    font-size: 22px
                    margin-bottom: 1em
                .desc
                    flex: 1
                .more
                    margin-top: 3em
    .more-btn
        cursor: pointer
        text-align: center
        font-size: 14px
        color: #c40000
        height: 100px
        background: #fff
        padding-top: 20px
        box-sizing: border-box
@media screen and (min-width: 1024px)
    .page
        width: 100%
        background: #f9f9f9
        padding-top: 100px
        .banner
            width: 100%
        .content-container
            max-width: 1000px
            margin: 0 auto
            min-height: 1030px
            padding-top: 60px
            .news-item
                cursor: pointer
                background: #fff
                display: flex
                margin-bottom: 30px
                transition: all 1s
                &:hover
                    box-shadow: 0 5px 5px 0px #eee
                img
                    background: #eee
                    display: block
                    width: 50%
                .content
                    padding: 30px
        .more-btn
            cursor: pointer
            text-align: center
            font-size: 14px
            color: #c40000
            height: 100px
            background: #fff
            padding-top: 20px
            box-sizing: border-box
</style>